<template>
  <div class='ct-flex-row'>
    <nav class='main-menu'>
      <header class='flex flex-column justify-center'>
        <h4>Détail de l'exploitation</h4>
        <h3>{{ nom }}</h3>
      </header>
      <ul>
        <li class='menu-item menu-infos'>
          <router-link :to='{name : "exploitation_information", params: {idExploitation}}'>Informations générales</router-link>
        </li>
        <li class='menu-item menu-exploitant'>
          <router-link :to='{name : "exploitation_exploitant", params: {idExploitation}}'>Exploitant</router-link>
        </li>
        <li class='menu-item menu-ilots'>
          <router-link :to='{name : "exploitation_ilots", params: {idExploitation}}'>Liste des îlots</router-link>
        </li>
        <li class='menu-item menu-cultures'>
          <router-link :to='{name : "exploitation_cultures", params: {idExploitation}}'>Liste des cultures</router-link>
        </li>
        <li class='menu-item menu-historique'>
          <router-link :to='{name : "exploitation_simulations", params: {idExploitation}}'>Historique des simulations</router-link>
        </li>
        <li v-can:edit-exploitation class='menu-item-link menu-simul' @click='createSimulation'>Lancer une simulation</li>
        <li v-can:create-exploitation class='menu-item-link menu-back'>
          <router-link :to='{name : "exploitations"}'>Revenir à la liste des exploitations</router-link>
        </li>
      </ul>
    </nav>
    <router-view class='item-flex-full main-ct' />
  </div>
</template>

<script>
import store from '@/store'

import Mixinsimulation from '@/mixins/simulation'

const loadExploitation = (next, idExploitation) => {
  store.dispatch('loadAnneesSeches', idExploitation)
  store.dispatch('loadSimuClim', idExploitation)
  store.dispatch('loadExploitation', idExploitation)
    .then(() => {
      next()
    })
    .catch(() => {
      next(false)
    })
}

export default {
  name: 'Exploitation',

  mixins: [Mixinsimulation],

  props: {
    idExploitation: {
      type: String,
      require: true
    }
  },

  computed: {
    nom () {
      return this.$store.getters.nomExploitation
    }
  },

  beforeRouteEnter (to, from, next) {
    loadExploitation(next, to.params.idExploitation)
  },

  beforeRouteUpdate (to, from, next) {
    let currentIdExploitation = this.$store.getters.exploitationId
    if (currentIdExploitation !== to.params.idExploitation) {
      loadExploitation(next, to.params.idExploitation)
    } else {
      next()
    }
  }

}
</script>
